const PropertyRoutes = {
  Properties: '/properties',
  PropertyDetails: '/properties/:propertyTokenId',
};

export const AppRoutes = {
  root: '/',
  Auth: '/auth',
  ...PropertyRoutes,
};
